module.exports = __webpack_public_path__ + "45c0a347c464922c8c409a2616d337e1.fbx";